import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-detail-popup',
  templateUrl: './detail-popup.component.html',
  styleUrls: ['./detail-popup.component.scss'],
})
export class DetailPopupComponent {
  constructor(readonly activeModal: NgbActiveModal) {}
  title: any;
  dataIn: any
  className: any
  @Output() modalEvent = new EventEmitter<any>();
  dimiss() {
    this.activeModal.close();
  }
  selectButton(item: any) {
    this.modalEvent.emit(item);
    this.activeModal.close();
  }
  public decline(): void {
    this.activeModal.close(false);
  }

  public accept(): void {
    this.activeModal.close(true);
  }
}
